<div class="modal-header">
    <h4 class="modal-title" translate>common.confirmModal.title.delete</h4>
    <button class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
    @if (!loading) {
        @if (reasons.length > 0) {
            <div>
                <p translate>users.deleteModal.notDeletableText</p>
                <ul>
                    @for (reason of reasons; track reason) {
                        <li>
                            {{ 'error.network.businessException.' + reason | translate }}
                        </li>
                    }
                </ul>
            </div>
        } @else if (reasons.length === 0) {
            <p class="translated-paragraph" translate>users.deleteModal.confirmMessage</p>
        }
    }
</div>

<div class="modal-footer">
    @if (!loading) {
        @if (reasons.length === 0) {
            <button type="button" class="btn btn-outline-secondary" (click)="no()" translate>
                common.no
            </button>

            <button type="button" class="btn btn-primary" (click)="yes()" translate>
                common.yes
            </button>
        } @else if (reasons.length > 0) {
            <button type="button" class="btn btn-primary" (click)="close()" translate>
                common.ok
            </button>
        }
    }
</div>
